import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["composing", "cancelButtonUse", "cancelLabel", "children", "className", "okButtonUse", "onCancel", "onOpenChange", "onSave", "open", "responsive", "saveDisabled", "saveOnEnter", "saveLabel", "use"];
import Controllable from '../decorators/Controllable';
import I18n from 'I18n';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import SyntheticEvent from '../core/SyntheticEvent';
import UIButton from '../button/UIButton';
import UISlideoutDrawer from '../slideout/UISlideoutDrawer';
import lazyEval from '../utils/lazyEval';
import { hidden } from '../utils/propTypes/decorators';
import createLazyPropType from '../utils/propTypes/createLazyPropType';
import IMEAware from '../decorators/IMEAware';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class UIEditableControls extends PureComponent {
  constructor(...args) {
    super(...args);
    this.handleFocus = evt => {
      const {
        onFocus,
        onOpenChange
      } = this.props;
      if (onOpenChange) onOpenChange(SyntheticEvent(true));
      if (onFocus) onFocus(evt);
    };
    this.handleKeyDown = evt => {
      const {
        saveDisabled,
        saveOnEnter,
        composing
      } = this.props;
      if (composing) return;
      const {
        key
      } = evt;
      if (key === 'Enter' && !saveDisabled && (saveOnEnter || evt.metaKey || evt.ctrlKey)) {
        this.handleSave();
      }
      if (key === 'Escape') {
        this.handleCancel();
      }
    };
    this.handleChange = () => {
      const {
        onOpenChange
      } = this.props;
      if (onOpenChange) onOpenChange(SyntheticEvent(true));
    };
    this.handleSave = () => {
      const {
        onOpenChange,
        onSave
      } = this.props;
      if (this._el) this._el.focus();
      if (onOpenChange) onOpenChange(SyntheticEvent(false));
      if (onSave) onSave();
    };
    this.handleCancel = () => {
      const {
        onCancel,
        onOpenChange
      } = this.props;
      if (this._el) this._el.focus();
      if (onOpenChange) onOpenChange(SyntheticEvent(false));
      if (onCancel) onCancel();
    };
  }
  render() {
    const _this$props = this.props,
      {
        cancelButtonUse,
        cancelLabel = () => I18n.text('salesUI.UIEditableControls.cancel'),
        children,
        className,
        okButtonUse,
        open,
        responsive,
        saveLabel = () => I18n.text('salesUI.UIEditableControls.save'),
        use
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const classes = classNames("uiEditableControls private-editable-control", className, use === 'flush' && 'private-editable-control--flush');
    return (
      /*#__PURE__*/
      /* eslint-disable jsx-a11y/no-static-element-interactions */
      _jsxs("div", Object.assign({
        className: classes,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyDown,
        ref: ref => {
          this._el = ref;
        }
      }, rest, {
        children: [children, /*#__PURE__*/_jsx(UISlideoutDrawer, {
          open: open,
          children: /*#__PURE__*/_jsxs("div", {
            className: "private-editable-control__controls",
            children: [/*#__PURE__*/_jsx(UIButton, {
              className: "private-editable-control__save",
              disabled: this.props.saveDisabled,
              onClick: this.handleSave,
              responsive: responsive,
              size: "extra-small",
              use: okButtonUse,
              children: lazyEval(saveLabel)
            }), /*#__PURE__*/_jsx(UIButton, {
              className: "private-editable-control__cancel",
              onClick: this.handleCancel,
              responsive: responsive,
              size: "extra-small",
              use: cancelButtonUse,
              children: lazyEval(cancelLabel)
            })]
          }, "controls")
        })]
      }))
      /* eslint-enable jsx-a11y/no-static-element-interactions */
    );
  }
}
const propTypes = {
  composing: hidden(PropTypes.bool),
  cancelButtonUse: PropTypes.string,
  cancelLabel: createLazyPropType(PropTypes.node).isRequired,
  children: PropTypes.node,
  okButtonUse: PropTypes.string,
  onCancel: PropTypes.func,
  onFocus: PropTypes.func,
  onOpenChange: PropTypes.func,
  onSave: PropTypes.func,
  open: PropTypes.bool,
  responsive: PropTypes.bool,
  saveDisabled: PropTypes.bool,
  saveLabel: createLazyPropType(PropTypes.node).isRequired,
  saveOnEnter: PropTypes.bool,
  use: PropTypes.oneOf(['inset', 'flush'])
};
UIEditableControls.propTypes = propTypes;
UIEditableControls.defaultProps = {
  cancelButtonUse: 'tertiary-light',
  cancelLabel: () => I18n.text('salesUI.UIEditableControls.cancel'),
  okButtonUse: 'tertiary',
  open: false,
  responsive: true,
  saveDisabled: false,
  saveLabel: () => I18n.text('salesUI.UIEditableControls.save'),
  saveOnEnter: true,
  use: 'inset'
};
UIEditableControls.displayName = 'UIEditableControls';
export default IMEAware(Controllable(UIEditableControls, ['open']));